import { TransactionsHistoryRequest, TransactionsLists } from 'vopay';
import { useState } from 'react';
import axios from 'axios';
import apiConfig from '@/services/api.config';

const { api } = apiConfig;

export default function useFetchTransactionsHistory() {
  const [fetching, setFetching] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [transactions, setTransactions] = useState<TransactionsLists[]>([]);
  const source = axios.CancelToken.source();

  async function fetchTransactionsHistory(req: TransactionsHistoryRequest) {
    try {
      setFetching(true);
      const res = await api.fetchTransactionsHistory(req, source);

      if (!res.Success) throw new Error(res.ErrorMessage);

      setTransactions(res.Transactions);
      setTotalRecords(res.PaginationMetaData.TotalRecords);

      return res;
    } finally {
      setFetching(false);
    }
  }

  return {
    fetching,
    fetchTransactionsHistory,
    transactions,
    totalRecords,
  };
}
